export default "__VITE_PUBLIC_ASSET__494a099f__"